import moment from "moment";

export const formatDateToYearAndMonth = (date) => {
    if (date) {
        let strDate = new Date(date);
        const formatedDate = moment(strDate).format("YYYY/MM");
        return formatedDate;
    }
};
